import classNames from 'classnames';
import React, {Fragment} from 'react';
import formatMessage from '../../../utils/formatMessage';
import ScreenReaderDetails from '../ScreenReaderDetails/ScreenReaderDetails';

import './Details.less';

export const DetailsItem = ({label, classname, value}) => {
    if (value && value > 0) {
        return (
            <div
                className={classNames(`Details__${classname}`, 'text-capitalize', 'Details__label')}
                aria-hidden="true"
            >
                <Fragment>
                    {value} {label}
                </Fragment>
            </div>
        );
    }
    return null;
};

export const HalfBathElement = ({bathroomsHalf, bathroomsToiletOnly, messages}) => {
    if (bathroomsHalf && bathroomsHalf > 0) {
        return (
            <DetailsItem
                label={messages.bathroomsHalfAbbreviation}
                classname="halfbathrooms"
                value={bathroomsHalf}
            />
        );
    } else if (bathroomsToiletOnly && bathroomsToiletOnly > 0) {
        return (
            <DetailsItem
                label={messages.bathroomsToiletOnlyAbbreviation}
                classname="halfbathrooms"
                value={bathroomsToiletOnly}
            />
        );
    }
    return null;
};

export const BedroomsPropertyTypeElement = ({
    bedrooms,
    propertyType,
    skipPropertyType,
    messages
}) => {
    return (
        <Fragment>
            {!skipPropertyType && (
                <div className="Details__propertyType Details__label" aria-hidden="true">
                    {propertyType}
                </div>
            )}
            {bedrooms > 0 && (
                <div className="Details__bedrooms Details__label" aria-hidden="true">
                    {formatMessage(messages.bedroomsAbbreviationParam, {
                        bedrooms
                    })}
                </div>
            )}
        </Fragment>
    );
};

export const SleepsElement = ({value, messages}) => {
    if (value && value > 0) {
        return (
            <div className="Details__sleeps Details__label" aria-hidden="true">
                {formatMessage(messages.sleepsAbbreviation, {
                    value
                })}
            </div>
        );
    }
    return null;
};

export const BathroomsElement = ({bathroomsFull, bathroomsHalf, bathroomsToiletOnly, messages}) => {
    if (bathroomsFull && bathroomsFull > 0) {
        return (
            <Fragment>
                <div className="Details__bathrooms Details__label" aria-hidden="true">
                    {formatMessage(messages.bathroomsFullAbbreviationParam, {
                        bathroomsFull
                    })}
                </div>
                <HalfBathElement
                    bathroomsHalf={bathroomsHalf}
                    bathroomsToiletOnly={bathroomsToiletOnly}
                    messages={messages}
                />
            </Fragment>
        );
    }
    return null;
};

export const AreaElement = ({areaValue, isMetric, messages}) => {
    return (
        !!(areaValue && areaValue > 0) && (
            <div className="Details__label" aria-hidden="true">
                {`${areaValue} `}
                {formatMessage(messages.areaLabel, {METRIC: isMetric})}
            </div>
        )
    );
};

const Details = ({
    bathrooms,
    bedrooms,
    propertyType,
    sleeps,
    spaces,
    isMetric,
    skipPropertyType,
    messages
}) => {
    const {half: bathroomsHalf, full: bathroomsFull, toiletOnly: bathroomsToiletOnly} =
        bathrooms || {};

    const areaValue =
        spaces &&
        spaces.spacesSummary &&
        spaces.spacesSummary.area &&
        spaces.spacesSummary.area.areaValue;
    return (
        <Fragment>
            <BedroomsPropertyTypeElement
                bedrooms={bedrooms}
                skipPropertyType={skipPropertyType}
                propertyType={propertyType}
                messages={messages}
            />
            <BathroomsElement
                bathroomsFull={bathroomsFull}
                bathroomsHalf={bathroomsHalf}
                bathroomsToiletOnly={bathroomsToiletOnly}
                messages={messages}
            />
            <SleepsElement value={sleeps} messages={messages} />
            <AreaElement areaValue={areaValue} isMetric={isMetric} messages={messages} />
            <ScreenReaderDetails
                bedrooms={bedrooms}
                propertyType={skipPropertyType ? null : propertyType}
                bathroomsFull={bathroomsFull}
                bathroomsHalf={bathroomsHalf}
                bathroomsToiletOnly={bathroomsToiletOnly}
                sleeps={sleeps}
                area={areaValue}
                isMetric={isMetric}
                messages={messages}
            />
        </Fragment>
    );
};

export default Details;
